/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/commonClasses/commonContextBase.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.Tax {
    "use strict";

    export class TaxContext extends Meevo.Components.CommonClasses.CommonContextBase {
        protected addSecurityKey: string;
        protected editSecurityKey: string;
        protected copySecurityKey: string;
        protected deleteSecurityKey: string;
        protected changeAccessSecurityKey: string;
        protected changeOwnerSecurityKey: string;
        protected loading: boolean;
        public auditNoun = Meevo.Model.NounEnum.CurrencyAndTax;

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            businessInfoDataService: Meevo.Components.CommonClasses.ICommonDataService,
            protected identityDataService: Meevo.Components.Common.ICommonDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $http: angular.IHttpService) {
            super(appSettings, businessInfoDataService, modalService, identityService, loggingService, securityChecker, trackingService);
            this.baseEndpoint = appSettings.API_ENDPOINTS.tax;
            this.sectionTemplatePath = "app/plugins/tax/sectionViews/";
            this.initializeSections();
            this.buildCrudSecurityKeysBase(this.securityKeys.BUSINESSINFO_FINANCIAL_TAB_MAIN, true);
        }

        initializeSections(): void {
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.BUSINESSINFO_FINANCIAL_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(
                    0,
                    "SECTION_TAX_MAIN",
                    "main.html",
                    true,
                    false,
                    this.baseEndpoint,
                    "",
                    this.loggingService,
                    this.dataService,
                    Meevo.Model.NounEnum.CurrencyAndTaxMain,
                    this.identityService,
                    this.appSettings,
                    this.modalService,
                    this.securityKeys.BUSINESSINFO_FINANCIAL_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                    ));

            }
            this.activate();
        }

        protected buildCrudSecurityKeysBase(baseKey, hasCreateKey = false, hasCopyKey = false) {
            this.editSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE;
            this.deleteSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_DELETE;
            this.addSecurityKey = baseKey + ((hasCreateKey) ? Meevo.Components.Common.SecurityParts.KEY_PART_CREATE : Meevo.Components.Common.SecurityParts.KEY_PART_WRITE);
            this.copySecurityKey = baseKey + ((hasCopyKey) ? Meevo.Components.Common.SecurityParts.KEY_PART_COPY : Meevo.Components.Common.SecurityParts.KEY_PART_WRITE);

        }

        initializeHeader(model: any): void {
            let taxModel = <Meevo.Model.Tax>model;
        }

        viewAuditDetail(taxId: Meevo.Guid, pageNumber: number): void {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/tax/sectionViews/view.taxHistory.html",
                clickOutsideToClose: true,
                controller: "meevo.plugins.tax.TaxAuditLogController",
                controllerAs: "vm",
                locals: {
                    taxId: taxId,
                    pageNumber: pageNumber,
                    itemsPerPage: 25,
                    startDateTime: null,
                    endDateTime: null
                }
            }
            this.modalService.showCustom(options);
        }

        save(): angular.IPromise<any> {
            let promise = super.save().then(() => {
                this.identityDataService.getIdentityFull().then((data: Meevo.Components.Common.IIdentity) => {
                    this.identityService.setIdentity(data);
                });
            });

            return promise;
        }
    }
}

